// extracted by mini-css-extract-plugin
var _1 = "Skeleton-modulecontainer__HGs3p";
var _2 = "Skeleton-modulecontent__WmZJ1";
export { _1 as "container", _2 as "content" }
